import { __assign } from "tslib";
import { GALLERY_CONSTS, utils } from 'pro-gallery-lib';
export function getContainerStyle(styleParams) {
    return __assign({}, ((styleParams.imageInfoType ===
        GALLERY_CONSTS.infoType.ATTACHED_BACKGROUND ||
        GALLERY_CONSTS.hasHoverPlacement(styleParams.titlePlacement)) && __assign(__assign({}, getBorderStyle(styleParams.itemBorderRadius, styleParams.itemBorderWidth, styleParams.itemBorderColor)), boxShadow(styleParams))));
}
function boxShadow(styleParams) {
    var _boxShadow = {};
    if (styleParams.itemEnableShadow) {
        var itemShadowBlur = styleParams.itemShadowBlur, itemShadowDirection = styleParams.itemShadowDirection, itemShadowSize = styleParams.itemShadowSize;
        var alpha = ((-1 * (Number(itemShadowDirection) - 90)) / 360) * 2 * Math.PI;
        var shadowX = Math.round(itemShadowSize * Math.cos(alpha));
        var shadowY = Math.round(-1 * itemShadowSize * Math.sin(alpha));
        _boxShadow = {
            boxShadow: shadowX + "px " + shadowY + "px " + itemShadowBlur + "px " + utils.formatColor(styleParams.itemShadowOpacityAndColor),
        };
    }
    return _boxShadow;
}
export function getImageStyle(styleParams) {
    return __assign({}, (!GALLERY_CONSTS.hasHoverPlacement(styleParams.titlePlacement) &&
        (styleParams.imageInfoType === GALLERY_CONSTS.infoType.NO_BACKGROUND ||
            styleParams.imageInfoType ===
                GALLERY_CONSTS.infoType.SEPARATED_BACKGROUND) && __assign({}, getBorderStyle(styleParams.itemBorderRadius, styleParams.itemBorderWidth, styleParams.itemBorderColor))));
}
function getBorderStyle(borderRadius, borderWidth, borderColor) {
    return __assign({ overflow: 'hidden', borderRadius: borderRadius, borderWidth: borderWidth + 'px', borderColor: utils.formatColor(borderColor) }, (borderWidth && {
        borderStyle: 'solid',
    }));
}
export function getOuterInfoStyle(placement, styleParams, mediaHeight, textBoxHeight) {
    var styles = __assign(__assign({}, (GALLERY_CONSTS.hasHorizontalPlacement(placement) && {
        height: mediaHeight,
        float: GALLERY_CONSTS.isRightPlacement(placement) ? 'right' : 'left',
    })), (GALLERY_CONSTS.hasVerticalPlacement(placement) && {
        height: textBoxHeight,
        boxSizing: 'content-box',
    }));
    if (styleParams.imageInfoType === GALLERY_CONSTS.infoType.SEPARATED_BACKGROUND) {
        return __assign(__assign(__assign(__assign({}, styles), getBorderStyle(styleParams.textBoxBorderRadius, styleParams.textBoxBorderWidth, styleParams.textBoxBorderColor)), (GALLERY_CONSTS.hasAbovePlacement(placement) && {
            marginBottom: styleParams.textImageSpace,
        })), (GALLERY_CONSTS.hasBelowPlacement(placement) && {
            marginTop: styleParams.textImageSpace,
        }));
    }
    return styles;
}
function getInnerInfoStylesAboveOrBelow(styleParams, infoHeight) {
    return {
        width: '100%',
        height: infoHeight,
    };
}
function getInnerInfoStylesRightOrLeft(styleParams, infoWidth) {
    return {
        height: '100%',
        width: infoWidth,
    };
}
export function getInnerInfoStyle(placement, styleParams, infoHeight, infoWidth) {
    var commonStyles = __assign(__assign({}, ((styleParams.imageInfoType ===
        GALLERY_CONSTS.infoType.SEPARATED_BACKGROUND ||
        styleParams.imageInfoType ===
            GALLERY_CONSTS.infoType.ATTACHED_BACKGROUND) &&
        styleParams.textBoxFillColor &&
        styleParams.textBoxFillColor.value && {
        backgroundColor: styleParams.textBoxFillColor.value,
    })), { overflow: 'hidden', boxSizing: 'border-box' });
    var infoAboveOrBelow = GALLERY_CONSTS.hasVerticalPlacement(placement);
    var infoRightOrLeft = GALLERY_CONSTS.hasHorizontalPlacement(placement);
    return __assign(__assign(__assign({}, commonStyles), (infoAboveOrBelow &&
        getInnerInfoStylesAboveOrBelow(styleParams, infoHeight))), (infoRightOrLeft &&
        getInnerInfoStylesRightOrLeft(styleParams, infoWidth)));
}
//# sourceMappingURL=itemViewStyleProvider.js.map